export const TRACK_REDUX_ACTIONS = [
    'draft/setDraftId',
    'draft/setDraftVersion',
];
// Note: Don't add large objects - Sentry will reject events over 200kB
export const SAVE_REDUX_STATE_PATHS = [
    'views.syi.draft.draftId',
    'views.syi.draft.itemId',
    'views.syi.draft.version',
    'views.syi.syi.autoSaveEnabled',
];
